import React, { CSSProperties, FC, memo } from "react"
import {
    BookerInput,
    Gender,
    GetAppSettingsDocument,
    GetUpdatedBookerQuery,
    OptionalInputFieldsInput,
    useUpdateBookerMutation,
} from "../../../../../generated/graphql"
import { omit } from "../../../../../helpers/omit"
import FormItem from "antd/lib/form/FormItem"
import { Checkbox } from "antd"
import { LoadingOutlined } from "@ant-design/icons/lib/icons"
import css from "../../StepSummary2.module.css"
// import { cleanupGraphQLData } from "../../../../../helpers/cleanupGraphQLData"

type NewsLetterInputProps = {
    field: OptionalInputFieldsInput
    booker: GetUpdatedBookerQuery["booker"]
    style?: CSSProperties
}

const NewsLetterInput: FC<NewsLetterInputProps> = ({ field, booker, style }) => {
    const { id, customer, gender, firstname, lastname, initialContact, dsgvo } = booker
    const bookersGender = gender as Gender
    const updateBookerData: BookerInput = {
        // Nur Bucher-Felder schicken: Teilnehmer- und Zahlartenlisten aus dem Cache können veraltet sein
        // (ko-X-main #1491/#1496), und der Newsletter-Haken ändert keine davon.
        ...omit(["createDate", "updateDate", "customerId", "attendees", "paymentMethods"], booker),
        id,
        customer,
        gender: bookersGender,
        firstname,
        lastname,
        initialContact,
        dsgvo,
    }

    const [updateBookerMutation, { loading }] = useUpdateBookerMutation()
    const updateBooker = async (checked: boolean) => {
        try {
            // const cleannedBookerData = cleanupGraphQLData({ ...updateBookerData, newsletter: checked })

            await updateBookerMutation({
                variables: { updateBookerData: { ...updateBookerData, newsletter: checked }, fromEndUserApp: true },
                refetchQueries: ["GetUpdatedBooker", { query: GetAppSettingsDocument }],
            })
        } catch (error) {
            console.log("error updateBookerMutation:", error)
        }
    }

    return (
        <>
            <FormItem style={style} key={field.name}>
                <Checkbox
                    className={css.inputLabel}
                    onChange={(e) => updateBooker(e.target.checked)}
                    checked={booker.newsletter}
                >
                    {loading ? <LoadingOutlined /> : field.label}
                </Checkbox>
                <div className={css.inputDescription}>{field.description}</div>
            </FormItem>
        </>
    )
}

export default memo(NewsLetterInput)
